<template>
  <div id="app">
    <PreLoader v-if="isLoading" class="pre-loader" />
    <TestI18n />
    <Navbar v-show="!isLoading" @start-loading="handleStartLoading" />

    <br />
    <router-view v-if="!isLoading" />
    <Footer />
    <!-- <WhatsappButton v-if="!isLoading" /> -->
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import PreLoader from "./components/Pre-loader.vue";
import Footer from "./components/Footer.vue";
import WhatsappButton from "./components/WhatsappButton.vue";

export default {
  name: "App",
  components: {
    Navbar,
    PreLoader,
    WhatsappButton,
    Footer,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    handleStartLoading() {
      this.isLoading = true;

      // Esperamos hasta que se hayan cargado las imágenes de la nueva vista
      this.$nextTick(() => {
        this.waitForImagesToLoad(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500); // Retardo de medio segundo para que el pre-loader termine de desaparecer
        });
      });
    },
    waitForImagesToLoad(callback) {
      const images = document.querySelectorAll("img");
      let loaded = 0;
      const total = images.length;

      if (total === 0) {
        callback();
        return;
      }

      const checkDone = () => {
        loaded++;
        if (loaded === total) {
          callback();
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          checkDone();
        } else {
          img.addEventListener("load", checkDone);
          img.addEventListener("error", checkDone);
        }
      });
    },
  },
  mounted() {
    this.waitForImagesToLoad(() => {
      setTimeout(() => {
        this.isLoading = false;
      }, 500); // Retardo de medio segundo para asegurar que todo cargue bien
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.pre-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
}

/* Estilos globales de scroll */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden; /* Evita el scroll horizontal */
  scroll-behavior: smooth; /* Transiciones suaves */
}

/* Mostrar el scroll vertical cuando sea necesario */
body {
  overflow-y: auto; /* Siempre visible el scroll vertical */
}

/* Estilo para el scrollbar */
::-webkit-scrollbar {
  width: 6px; /* Ancho del scroll (más delgado) */
  transition: width 0.3s ease; /* Transición suave */
}

::-webkit-scrollbar-track {
  background: transparent; /* Fondo del track invisible */
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(
    180deg,
    #2a9c44,
    #ff6f00
  ); /* Degradado verde a naranja */
  border-radius: 10px; /* Bordes redondeados */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2); /* Efecto 3D */
  transition: background 0.3s ease, box-shadow 0.3s ease; /* Transiciones suaves */
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(
    180deg,
    #2a9c44,
    #ff8f00
  ); /* Hover con colores más intensos */
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.3); /* Efecto 3D al pasar el mouse */
}

/* Estilo para Firefox */
* {
  scrollbar-width: thin; /* Scroll delgado para Firefox */
  scrollbar-color: #2a9c44 #f1f1f1; /* Verde y fondo claro en Firefox */
}
</style>
